import { UseControllerProps } from 'react-hook-form';

export const DRIVING_LICENSE_REGEX: UseControllerProps['rules'] = {
  pattern: {
    value: /^[0-9]{10}$/,
    message: 'شماره گواهینامه رانندگی نامعتبر است',
  },
};
